// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


// API URLs



import { GbNavigation } from './urlFactory/gb-navigation';
import { GbCiamCommonUtil } from './urlFactory/gb-ciam-common-util';
import { ProtocolMode } from '@azure/msal-browser';
import { env } from './environment-loader';

export class Environment {
    constructor(private clientId: Map<string, string>,
        private baseUrl: string,
        private envName: string,
        private mockingSet: boolean,
        private prodState: boolean,
        private proxyState: boolean,
        private ciamAccountUrl: string,
        private sfdAccountUrl: string,
        private ciamApiSgwUrl: string,
        private agentLessToggle: boolean
    ) {
    }

    getEnv() {
        return {
            // Common Application parameters
            production: this.prodState,
            mocking: this.mockingSet,
            envName: this.envName,
            myBaseUrl: this.baseUrl,
            myClientId: this.clientId,
            proxyState: this.proxyState,
            ciamAccountUrl: this.ciamAccountUrl,
            sfdAccountUrl: this.sfdAccountUrl,
            ciamApiSgwUrl: this.ciamApiSgwUrl,
            gbCiamCommonUtil: new GbCiamCommonUtil(this.clientId, this.baseUrl, this.envName, this.ciamAccountUrl, this.sfdAccountUrl, this.ciamApiSgwUrl).getUrls(),
            gbNavigation: new GbNavigation(this.clientId, this.baseUrl, this.envName).getUrl(),
            agentLessToggle: this.agentLessToggle
        };
    }
}

// msal configuration for environments
export const MSAL_CONFIG_MAP = {
    production: false,
    scopes: ['openid'],
    localhost: {
        '/agency': {
            revokeAPI:
                'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Agency/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-er-A6G6E3N1',
                authority: 'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Agency',
                redirectUri: 'http://localhost.thehartford.com:4200/',
                knownAuthorities: ['https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Agency/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                allowRedirectInIframe: true
            }
        },
        '/partners': {
            revokeAPI:
                'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Partners/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-P0A8R5T5',
                authority: 'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Partners',
                redirectUri: 'http://localhost.thehartford.com:4200/',
                knownAuthorities: ['https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Partners/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                allowRedirectInIframe: true
            }
        },
        '/customers': {
            revokeAPI:
                'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Customers/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-C9U5S2T5',
                authority: 'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Customers',
                redirectUri: 'http://localhost.thehartford.com:4200/',
                knownAuthorities: ['https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Customers/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                allowRedirectInIframe: true
            }
        },
        '/employees': {
            revokeAPI:
                'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Employees/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-XL9YRG3C',
                authority: 'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Employees',
                redirectUri: 'http://localhost.thehartford.com:4200/',
                knownAuthorities: ['https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Employees/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                allowRedirectInIframe: true
            }
        },
        apiConfig: {}
    },
    dev1: {
        '/agency': {
            revokeAPI:
                'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Agency/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-er-A6G6E3N1',
                authority: 'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Agency',
                redirectUri: 'https://dev1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Agency/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                allowRedirectInIframe: true
            }
        },
        '/partners': {
            revokeAPI:
                'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Partners/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-P0A8R5T5',
                authority: 'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Partners',
                redirectUri: 'https://dev1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Partners/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                allowRedirectInIframe: true
            }
        },
        '/customers': {
            revokeAPI:
                'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Customers/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-C9U5S2T5',
                authority: 'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Customers',
                redirectUri: 'https://dev1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Customers/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                allowRedirectInIframe: true
            }
        },
        '/employees': {
            revokeAPI:
                'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Employees/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-XL9YRG3C',
                authority: 'https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Employees',
                redirectUri: 'https://dev1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://ciam-am-dev.thehartford.com:443/openam/oauth2/realms/root/realms/Employees/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                allowRedirectInIframe: true
            }
        },
        apiConfig: {}
    },
    pt1: {
        '/agency': {
            revokeAPI:
                'https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Agency/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-er-A6G6E3N1',
                authority: 'https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Agency',
                redirectUri: 'https://pt1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Agency/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/partners': {
            revokeAPI:
                'https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Partners/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-U8P8F5T4',
                authority: 'https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Partners',
                redirectUri: 'https://pt1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Partners/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/customers': {
            revokeAPI:
                'https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Customers/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-N9P5D2J6',
                authority: 'https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Customers',
                redirectUri: 'https://pt1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Customers/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/employees': {
            revokeAPI:
                'https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Employees/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-W2T8PF2A',
                authority: 'https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Employees',
                redirectUri: 'https://pt1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-pte.thehartford.com/openam/oauth2/realms/root/realms/Employees/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        apiConfig: {}
    },
    qa1: {
        '/agency': {
            revokeAPI:
                'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Agency/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-er-A6G6E3N1',
                authority: 'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Agency',
                redirectUri: 'https://qa1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Agency/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/partners': {
            revokeAPI:
                'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Partners/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-Q9N4S9A3',
                authority: 'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Partners',
                redirectUri: 'https://qa1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Partners/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/customers': {
            revokeAPI:
                'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Customers/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-Q0S7R8D3',
                authority: 'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Customers',
                redirectUri: 'https://qa1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Customers/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/employees': {
            revokeAPI:
                'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Employees/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-T7Q3RA5Y',
                authority: 'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Employees',
                redirectUri: 'https://qa1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Employees/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        apiConfig: {}
    },
    sqa1: {
        '/agency': {
            revokeAPI:
                'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Agency/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-er-A6G6E3N1',
                authority: 'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Agency',
                redirectUri: 'https://sqa1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Agency/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/partners': {
            revokeAPI:
                'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Partners/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-Q9N4S9A3',
                authority: 'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Partners',
                redirectUri: 'https://sqa1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Partners/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/customers': {
            revokeAPI:
                'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Customers/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-Q0S7R8D3',
                authority: 'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Customers',
                redirectUri: 'https://sqa1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Customers/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/employees': {
            revokeAPI:
                'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Employees/connect/revoke',
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-Q0S7R8D3',
                authority: 'https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Employees',
                redirectUri: 'https://sqa1-ebaccount.thehartford.com/',
                knownAuthorities: ['https://account-access-qa.thehartford.com/openam/oauth2/realms/root/realms/Employees/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        apiConfig: {}
    },
    prod: {
        '/agency': {            
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-er-A6G6E3N1',
                authority: 'https://account-access.thehartford.com/openam/oauth2/realms/root/realms/Agency',
                redirectUri: 'https://gbaccount.thehartford.com/',
                knownAuthorities: ['https://account-access.thehartford.com/openam/oauth2/realms/root/realms/Agency/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/partners': {            
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-E9N3T9C6',
                authority: 'https://account-access.thehartford.com/openam/oauth2/realms/root/realms/Partners',
                redirectUri: 'https://gbaccount.thehartford.com/',
                knownAuthorities: ['https://account-access.thehartford.com/openam/oauth2/realms/root/realms/Partners/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/customers': {           
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-N3S3C4D9',
                authority: 'https://account-access.thehartford.com/openam/oauth2/realms/root/realms/Customers',
                redirectUri: 'https://gbaccount.thehartford.com/',
                knownAuthorities: ['https://account-access.thehartford.com/openam/oauth2/realms/root/realms/Customers/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        '/employees': {            
            auth: {
                // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
                clientId: 'eb-sfd-H3P9L3B6',
                authority: 'https://account-access.thehartford.com/openam/oauth2/realms/root/realms/Employees',
                redirectUri: 'https://gbaccount.thehartford.com/',
                knownAuthorities: ['https://account-access.thehartford.com/openam/oauth2/realms/root/realms/Employees/.well-known/openid-configuration'],
                protocolMode: ProtocolMode.OIDC,
                OIDCOptions: {
                    defaultScopes: ['openid'],
                },

                cloudDiscoveryMetadata: '',
                postLogoutRedirectUri: null,
                navigateToLoginRequestUrl: true,
                clientCapabilities: [],
                skipAuthorityMetadataCache: true,
                responseType: 'code', // Ensures PKCE is used
            },
            cache: {
                cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        },
        apiConfig: {}
    }
};
